import React from "react";
import { Routes, Route } from "react-router-dom";
import Login from "./Layout/login/Login";
import Dashboard from "./Layout/Dashboard/Dashboard";
import Chat from "./Layout/Chat/Chat";
import Contacts from "./Layout/Contacts/Contact";
import Main from "./Layout/Main/Main";
import PowerBi from "./Layout/PowerBi/PowerBi";
import PowerBiV2 from "./Layout/powerBiv2/powerBi";
import PowerBiDashboard from "./Layout/PowerBi Dashboard/PowerBiDashboard";
import Bank from "./Layout/BankPage/Bank";
import MultimediaSearch from "./Layout/Multimedia/MultimediaSearch";
import Cms from "./Layout/CMS/Cms";
import AgentContact from "./Layout/AgentContact/AgentContact";
import Statistic from "./Components/WebStatistic-component/WebStatistic";
import QueueChat from "./Layout/QueueChat/QueueChat";
import SupervisorContact from "./Layout/SupervisorContact/SupervisorContact";
import Reports from "./Layout/Reports/Reports";
import SessionReports from "./Components/Reports-component/SessionReports";
import MissedCall from "./Layout/MissedCall/MissedCall";
import Campaign from "./Layout/Campaign/Campaign";
import SalesReport from "./Layout/SalesReport/SalesReport";
import ServiceReport from "./Layout/ServiceReport/ServiceReport";
import CustomerDetails from "./Layout/CustomerDetails/CustomerDetails";
import MakeCall from "./Layout/MakeCall/MakeCall";
import WhatsappOutboundReport from "./Components/Reports-component/WhatsappOutboundReport";
import Pagenotfound from "./Components/pageNotFound/Pagenotfound";
import CallQueries from "./Layout/CallQueries/CallQueries";
import UCCallRecording from "./Layout/UCCallRecording/UCCallRecording";
import TotalDetailReport from "./Components/Reports-component/TotalDetailReport";
import SupervisorDashboard from "./Layout/SupervisorDashboard/SupervisorDashboard";
import RealTimeDash from "./Layout/RealtimeDashboard/RealtimeDashboard";
const App = () => {
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/main" element={<Main />}>
        <Route path="Dashboard" element={<Dashboard />} />
        {/* <Route path="supervisorDashboard" element={<SupervisorDashboard />} /> */}
        <Route path="RealTimeDashboard" element={<RealTimeDash />} />
        <Route path="Chat" element={<Chat />} />
        <Route path="CMS" element={<Cms />} />
        <Route path="Agent-Contact" element={<AgentContact />} />
        <Route path="customerdetails" element={<CustomerDetails />} />
        <Route
          path="SessionReports"
          element={<SessionReports show={false} />}
        />
                <Route
          path="totaldetailsreport"
          element={<TotalDetailReport show={false} />}
        />
        <Route path="Contacts" element={<Contacts />} />
        <Route path="Queue-Chat" element={<QueueChat />} />
        <Route path="powerBi" element={<PowerBi />} />
        <Route path="powerBiv2" element={<PowerBiV2 />} />
        <Route path="powerBiDashboard" element={<PowerBiDashboard />} />
        <Route path="multimediasearch" element={<MultimediaSearch />} />
        <Route path="supervisor" element={<MultimediaSearch />} />
        <Route path="supervisorContact" element={<SupervisorContact />} />
        <Route path="statistic" element={<Statistic />} />
        <Route path="reports" element={<Reports />} />
        <Route path="salesreport" element={<SalesReport />} />
        <Route path="servicereport" element={<ServiceReport />} />
        <Route path="callqueries" element={<CallQueries />} />
        <Route path="UCCallRecording" element={<UCCallRecording />} />
        <Route
          path="WhatsappoutboundReport"
          element={<WhatsappOutboundReport />}
        />
        
        <Route path="Campaign" element={<Campaign />} />
        <Route path="MissedCalls" element={<MissedCall />} />
        <Route path="makecall" element={<MakeCall />} />
        <Route path="*" element={<Pagenotfound />} />
      </Route>
      <Route path="customerPortal" element={<Bank />} />
    </Routes>
  );
};

export default App;
